// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_if-6";
export var emphasizeQuantity = "_if-3";
export var flatBottomCorners = "_if-5";
export var productImage = "_if-0";
export var quantityContainer = "_if-2";
export var tooltip = "_if-1";
export var wrapAndEllipsesOverflow = "_if-4";